import type { PageTemplateProps } from "./pageTemplateTypes";

export function ForkPageTemplate({ slots }: PageTemplateProps) {
  return (
    <div className="scha__fork">
      <div className="scha__fork__background" id="forkBackground">
        {slots.renderSlot("Background")}
      </div>
      <div className="scha__fork__foreground">{slots.renderSlot("Foreground")}</div>
    </div>
  );
}
